<template>
  <div class="property-contents-container">
    <ModelAppearanceTabs
      v-if="hasAppearance"
      v-model:tab="currentTab"
      :component-width="componentWidth"
    ></ModelAppearanceTabs>
    <v-window v-model="currentTab" style="height: 100%" transition="none" reverse-transition="none">
      <!-- MODEL -->
      <v-window-item value="model">
        <named-element-model-properties :model="model" @notify-change="emitChange" @entry-type-change="emitEntryTypeChange"></named-element-model-properties>
      </v-window-item>

      <!-- APPEARANCE -->
      <v-window-item v-if="hasAppearance" value="appearance">
        <named-element-appearance-properties :model="model"></named-element-appearance-properties>
      </v-window-item>
    </v-window>
  </div>
</template>

<script setup lang="ts">
import type NamedElement from "../mvc/base/named-element";
import { Entry } from "../mvc/entry";
import { Exit } from "../mvc/exit";
import { computed } from "vue";
import ModelAppearanceTabs from "./ModelAppearanceTabs.vue";
import NamedElementModelProperties from "./NamedElementModelProperties.vue";
import NamedElementAppearanceProperties from "./NamedElementAppearanceProperties.vue";

const compProps = defineProps<{
  model: NamedElement;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tab: any;
  componentWidth: number;
}>();
const emit = defineEmits(["entry-type-change", "notifyChange", "update:tab"]);

const currentTab = computed({
  get() {
    return compProps.tab;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set(tab: any) {
    emit("update:tab", tab);
  },
});

function emitChange(model) {
  emit("notifyChange", model);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function emitEntryTypeChange(value: any) {
  emit("entry-type-change", value);
}

const hasAppearance = computed(() => {
  return compProps.model instanceof Entry || compProps.model instanceof Exit;
});
</script>

